const getMailResponseStatus = (state) => (state.sendMail.mailResponseStatus);

export default getMailResponseStatus;
